import { getCurrentEnvironment } from '@/utilities/getEnvironment'

const ENV = getCurrentEnvironment()

export const STYTCH_ACTIVE_SESSION_DURATION = ENV === 'development' ? 1440 : 60

// The maximum session duration on the Stytch Frontend SDK page is 4320 minutes (3 days) as of 2025/09/17.
export const STYTCH_MAX_SESSION_DURATION_MINUTES = 4320
